<template>
  <el-select 
    v-model="selectedValue"
    :style="{width: width}"
    placeholder="请选择账户"
    clearable
    filterable
  >
    <el-option
      v-for="item in accountList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'AccountLov',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: '150px'
    }
  },
  data() {
    return {
      accountList: [],
      selectedValue: this.value
    }
  },
  watch: {
    selectedValue(newVal) {
      this.$emit('callBack', this.accountList?.find(item => item.id === newVal))
    },
    value(newVal) {
      this.selectedValue = newVal
    }
  },
  mounted() {
    this.fetchAccountList()
  },
  methods: {
    async fetchAccountList() {
      try {
        const res = await requestTicket.post('/Ticketing/account/findAll')
        this.accountList = res.data || []
      } catch (error) {
        console.error('获取账户列表失败:', error)
      }
    }
  }
}
</script>